import { AccessDeniedError, UnexpectedError } from "../../domain/errors";
import { PositionNotFountError } from "../../domain/errors/position-not-found-error";
import { UnauthorizedError } from "../../domain/errors/unauthorized-error";
import { Inventory } from "../../domain/models/inventory";
import { LoadInventoryByEan } from "../../domain/usecases/load-inventory-by-ean";

import { HttpClient, HttpStatusCode } from "../protocols/http";

export class DbLoadInventoryByEan implements LoadInventoryByEan {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient
  ) {}
  async load(params: {
    codes?: string[];
    warehouseId: number;
  }): Promise<Inventory[]> {
    const res = await this.httpClient.request({
      url: this.url,
      method: "get",
      params,
    });

    switch (res.statusCode) {
      case HttpStatusCode.ok:
        return res.body;
      case HttpStatusCode.forbidden:
        throw new AccessDeniedError();
      case HttpStatusCode.noContent:
        throw new PositionNotFountError();
      case HttpStatusCode.unauthorized:
        throw new UnauthorizedError();
      default:
        throw new UnexpectedError();
    }
  }
}
